import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { logError } from 'lib/sentry/logError';
import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

import { useChatInterlocutorContext } from 'features/chat/context/chatInterlocutor';

export const useChatMessageScheduleDelete = () => {
  const { chatId } = useChatInterlocutorContext();
  const { request } = useMutationHTTPRequest();
  const queryClient = useQueryClient();

  return useMutation(
    async (messageId: string) =>
      request({
        url: `/api/chats/${chatId}/scheduled-messages/${messageId}/delete`,
      }),
    {
      onSettled: () => {
        queryClient.invalidateQueries([queryKeys.scheduledMessages, chatId]);
      },
      onError: (error) => {
        logError(error);
      },
    }
  );
};
